export * from './acesso-externo.component';